<template>
  <div class="streamers">
    <!-- 主要内容区 -->
    <main class="max-w-7xl mx-auto px-4 py-8">
      <!-- 搜索和筛选 -->
      <div class="bg-white rounded-lg shadow-md p-6 mb-8">
        <div class="flex flex-wrap items-center gap-4">
          <div class="flex-1">
            <div class="relative">
              <input 
                type="text" 
                placeholder="搜索主播..." 
                class="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-purple-500"
                v-model="searchQuery"
              >
              <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
            </div>
          </div>
          <select 
            v-model="statusFilter" 
            class="border rounded-lg px-4 py-2 focus:outline-none focus:border-purple-500"
          >
            <option value="all">{{ $store.getters.t('all') }}</option>
            <option value="online">{{ $store.getters.t('online') }}</option>
            <option value="offline">{{ $store.getters.t('offline') }}</option>
            <option value="pending">{{ $store.getters.t('status_pending') }}</option>
          </select>
          <select 
            v-model="levelFilter" 
            class="border rounded-lg px-4 py-2 focus:outline-none focus:border-purple-500"
          >
            <option value="all">{{ $store.getters.t('all') }}</option>
            <option value="s">S级</option>
            <option value="a">A级</option>
            <option value="b">B级</option>
            <option value="c">C级</option>
          </select>
          <button class="bg-gray-100 px-4 py-2 rounded-lg hover:bg-gray-200">
            <i class="fas fa-filter mr-2"></i>{{ $store.getters.t('more') }}
          </button>
          <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700">
            <i class="fas fa-plus mr-2"></i>{{ $store.getters.t('add_streamer') }}
          </button>
        </div>
      </div>

      <!-- 主播列表 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <!-- 主播卡片 1 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden card-hover">
          <div class="relative">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="主播头像" class="w-full h-48 object-cover">
            <div class="absolute top-4 right-4">
              <span class="bg-green-500 text-white px-2 py-1 rounded-full text-sm">直播中</span>
            </div>
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <div>
                <h3 class="text-xl font-bold">小美</h3>
                <p class="text-gray-600">ID: 10086</p>
              </div>
              <span class="bg-purple-100 text-purple-600 px-3 py-1 rounded-full text-sm">S级</span>
            </div>
            <div class="grid grid-cols-3 gap-4 mb-4">
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('fans') }}</p>
                <p class="font-bold">128.5K</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('income') }}</p>
                <p class="font-bold">¥89,432</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('live_hours') }}</p>
                <p class="font-bold">156h</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <button @click="viewStreamerDetail('10086')" class="text-purple-600 hover:text-purple-700">
                <i class="fas fa-chart-line mr-1"></i>{{ $store.getters.t('data') }}
              </button>
              <button @click="viewStreamerDetail('10086')" class="text-blue-600 hover:text-blue-700">
                <i class="fas fa-eye mr-1"></i>{{ $store.getters.t('view_detail') }}
              </button>
              <button class="text-gray-600 hover:text-gray-700">
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- 主播卡片 2 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden card-hover">
          <div class="relative">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="主播头像" class="w-full h-48 object-cover">
            <div class="absolute top-4 right-4">
              <span class="bg-gray-500 text-white px-2 py-1 rounded-full text-sm">休息中</span>
            </div>
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <div>
                <h3 class="text-xl font-bold">阿杰</h3>
                <p class="text-gray-600">ID: 10087</p>
              </div>
              <span class="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm">A级</span>
            </div>
            <div class="grid grid-cols-3 gap-4 mb-4">
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('fans') }}</p>
                <p class="font-bold">89.2K</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('income') }}</p>
                <p class="font-bold">¥67,890</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('live_hours') }}</p>
                <p class="font-bold">142h</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <button @click="viewStreamerDetail('10087')" class="text-purple-600 hover:text-purple-700">
                <i class="fas fa-chart-line mr-1"></i>{{ $store.getters.t('data') }}
              </button>
              <button @click="viewStreamerDetail('10087')" class="text-blue-600 hover:text-blue-700">
                <i class="fas fa-eye mr-1"></i>{{ $store.getters.t('view_detail') }}
              </button>
              <button class="text-gray-600 hover:text-gray-700">
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- 主播卡片 3 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden card-hover">
          <div class="relative">
            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="主播头像" class="w-full h-48 object-cover">
            <div class="absolute top-4 right-4">
              <span class="bg-yellow-500 text-white px-2 py-1 rounded-full text-sm">待审核</span>
            </div>
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <div>
                <h3 class="text-xl font-bold">小丽</h3>
                <p class="text-gray-600">ID: 10088</p>
              </div>
              <span class="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm">B级</span>
            </div>
            <div class="grid grid-cols-3 gap-4 mb-4">
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('fans') }}</p>
                <p class="font-bold">45.8K</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('income') }}</p>
                <p class="font-bold">¥34,567</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('live_hours') }}</p>
                <p class="font-bold">98h</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <button @click="viewStreamerDetail('10088')" class="text-purple-600 hover:text-purple-700">
                <i class="fas fa-chart-line mr-1"></i>{{ $store.getters.t('data') }}
              </button>
              <button @click="viewStreamerDetail('10088')" class="text-blue-600 hover:text-blue-700">
                <i class="fas fa-eye mr-1"></i>{{ $store.getters.t('view_detail') }}
              </button>
              <button class="text-gray-600 hover:text-gray-700">
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- 主播卡片 4 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden card-hover">
          <div class="relative">
            <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="主播头像" class="w-full h-48 object-cover">
            <div class="absolute top-4 right-4">
              <span class="bg-green-500 text-white px-2 py-1 rounded-full text-sm">直播中</span>
            </div>
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <div>
                <h3 class="text-xl font-bold">大壮</h3>
                <p class="text-gray-600">ID: 10089</p>
              </div>
              <span class="bg-purple-100 text-purple-600 px-3 py-1 rounded-full text-sm">S级</span>
            </div>
            <div class="grid grid-cols-3 gap-4 mb-4">
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('fans') }}</p>
                <p class="font-bold">256.3K</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('income') }}</p>
                <p class="font-bold">¥156,789</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('live_hours') }}</p>
                <p class="font-bold">234h</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <button @click="viewStreamerDetail('10088')" class="text-purple-600 hover:text-purple-700">
                <i class="fas fa-chart-line mr-1"></i>{{ $store.getters.t('data') }}
              </button>
              <button @click="viewStreamerDetail('10088')" class="text-blue-600 hover:text-blue-700">
                <i class="fas fa-eye mr-1"></i>{{ $store.getters.t('view_detail') }}
              </button>
              <button class="text-gray-600 hover:text-gray-700">
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- 主播卡片 5 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden card-hover">
          <div class="relative">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="主播头像" class="w-full h-48 object-cover">
            <div class="absolute top-4 right-4">
              <span class="bg-gray-500 text-white px-2 py-1 rounded-full text-sm">休息中</span>
            </div>
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <div>
                <h3 class="text-xl font-bold">小芳</h3>
                <p class="text-gray-600">ID: 10090</p>
              </div>
              <span class="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm">A级</span>
            </div>
            <div class="grid grid-cols-3 gap-4 mb-4">
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('fans') }}</p>
                <p class="font-bold">78.9K</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('income') }}</p>
                <p class="font-bold">¥56,234</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('live_hours') }}</p>
                <p class="font-bold">167h</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <button @click="viewStreamerDetail('10088')" class="text-purple-600 hover:text-purple-700">
                <i class="fas fa-chart-line mr-1"></i>{{ $store.getters.t('data') }}
              </button>
              <button @click="viewStreamerDetail('10088')" class="text-blue-600 hover:text-blue-700">
                <i class="fas fa-eye mr-1"></i>{{ $store.getters.t('view_detail') }}
              </button>
              <button class="text-gray-600 hover:text-gray-700">
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- 主播卡片 6 -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden card-hover">
          <div class="relative">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="主播头像" class="w-full h-48 object-cover">
            <div class="absolute top-4 right-4">
              <span class="bg-green-500 text-white px-2 py-1 rounded-full text-sm">直播中</span>
            </div>
          </div>
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <div>
                <h3 class="text-xl font-bold">阿强</h3>
                <p class="text-gray-600">ID: 10091</p>
              </div>
              <span class="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm">B级</span>
            </div>
            <div class="grid grid-cols-3 gap-4 mb-4">
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('fans') }}</p>
                <p class="font-bold">34.2K</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('income') }}</p>
                <p class="font-bold">¥23,456</p>
              </div>
              <div class="text-center">
                <p class="text-gray-500 text-sm">{{ $store.getters.t('live_hours') }}</p>
                <p class="font-bold">89h</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <button @click="viewStreamerDetail('10088')" class="text-purple-600 hover:text-purple-700">
                <i class="fas fa-chart-line mr-1"></i>{{ $store.getters.t('data') }}
              </button>
              <button @click="viewStreamerDetail('10088')" class="text-blue-600 hover:text-blue-700">
                <i class="fas fa-eye mr-1"></i>{{ $store.getters.t('view_detail') }}
              </button>
              <button class="text-gray-600 hover:text-gray-700">
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="flex justify-center mt-8">
        <nav class="flex items-center space-x-2">
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="px-3 py-1 rounded-lg bg-purple-600 text-white">1</button>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">2</button>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">3</button>
          <span class="px-2">...</span>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">10</button>
          <button class="px-3 py-1 rounded-lg border hover:bg-gray-100">
            <i class="fas fa-chevron-right"></i>
          </button>
        </nav>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'StreamersPage',
  data() {
    return {
      searchQuery: '',
      statusFilter: 'all',
      levelFilter: 'all'
    }
  },
  methods: {
    viewStreamerDetail(streamerId) {
      this.$router.push(`/streamer-detail/${streamerId}`)
    }
  }
}
</script>

<style scoped>
.streamers {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.gap-6 {
  gap: 1.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mt-8 {
  margin-top: 2rem;
}

.p-6 {
  padding: 1.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-600 {
  color: #4b5563;
}

.text-purple-600 {
  color: #9333ea;
}

.text-blue-600 {
  color: #2563eb;
}

.text-green-600 {
  color: #16a34a;
}

.text-white {
  color: #ffffff;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-purple-600 {
  background-color: #9333ea;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.bg-green-500 {
  background-color: #10b981;
}

.bg-gray-500 {
  background-color: #6b7280;
}

.bg-yellow-500 {
  background-color: #f59e0b;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.border {
  border-width: 1px;
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\:border-purple-500:focus {
  border-color: #9333ea;
}

.hover\:bg-gray-200:hover {
  background-color: #e5e7eb;
}

.hover\:bg-purple-700:hover {
  background-color: #7c3aed;
}

.hover\:text-purple-700:hover {
  color: #7c3aed;
}

.hover\:text-blue-700:hover {
  color: #1d4ed8;
}

.hover\:text-gray-700:hover {
  color: #374151;
}

.text-sm {
  font-size: 0.875rem;
}

.w-full {
  width: 100%;
}

.h-48 {
  height: 12rem;
}

.object-cover {
  object-fit: cover;
}

.overflow-hidden {
  overflow: hidden;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.top-4 {
  top: 1rem;
}

.right-4 {
  right: 1rem;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.space-x-2 > * + * {
  margin-left: 0.5rem;
}

.text-center {
  text-align: center;
}
</style> 